import ky from 'ky';

import getAccessToken from '../utils/get-access-token';
import getAccounts from '../utils/get-accounts';
import getCampaign from '../utils/get-campaign';
import getClauseCampaigns from '../utils/get-clause-campaigns';
import { getHeaderFilterPermissions } from '../utils/header-filter-permissions';
import getOrdersYear from '../utils/get-orders-year';
import getOrganisation from '../utils/get-organisation';

export const publicClient = ky.extend({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - import is used by vite
  prefixUrl: import.meta.env.VITE_API_URL,
});

export const privateClient = publicClient.extend({
  hooks: {
    beforeRequest: [
      (request) => {
        const accessToken = getAccessToken();
        const locale = localStorage.getItem('i18nextLng') || 'fr';

        request.headers.set('Content-Language', locale);

        if (accessToken) {
          request.headers.set('Authorization', `Token ${accessToken}`);
          // add the campaign year to the query params
          // const campaign = getCampaign();
          // request.headers.set('X-Campaign-Year', campaign);

          const ordersYear = getOrdersYear();
          if (ordersYear) {
            // request.headers.set('X-Orders-Year', ordersYear.toString());
          }

          const headerFilters = getHeaderFilterPermissions();

          const accounts = getAccounts();
          if (headerFilters.accounts && accounts?.length) {
            request.headers.set('X-Accounts', JSON.stringify(accounts));
          }

          const organisation = getOrganisation();
          if (headerFilters.organisation && organisation?.length) {
            request.headers.set('X-Organisation', JSON.stringify(organisation));
          }

          const clauseCampaigns = getClauseCampaigns();
          if (clauseCampaigns?.length) {
            request.headers.set('X-Clause', JSON.stringify(clauseCampaigns));
          }
        }
      },
    ],
  },
});
